import React, {useRef, useState} from 'react';
import {useParams} from "react-router-dom";
import {Box, useMediaQuery, useTheme} from "@mui/material";
import {useCourses} from "../../hooks/useCourses";
import ExploreAllCards from "../../components/exploreAllCards/exploreAllCards";
import "../../components/exploreAllCards/exploreAllCards.scss";
import PageLoader from "../../components/loader/loader";
import BreadcrumbsNav from "../../components/navigation/breadcrumbs-nav/BreadcrumbsNav";
import type { BreadcrumbItem } from "../../components/navigation/types/BreadcrumbItem";
export default function ExploreAll() {
    const params = useParams();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [
        filterData,
        loaded,
        courses,
        handleFilterTypeCheckboxChange,
        handleFilterCheckboxChange,
        selectedFilters,
        handleResetFilter,
    ] = useCourses();
    const containerRef = useRef<HTMLDivElement>(null);
    const [containerWidth, setContainerWidth] = useState(0);
    const updateContainerWidth = () => {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.offsetWidth);
        }
    };


    const getFirstPathSegment = () => {
        const pathSegments = window.location.pathname.split('/').filter(segment => segment);
        return pathSegments.length > 0 ? pathSegments[0] : '';
    };

    const transformString = (input: string) => {
        return input
            .replace(/-/g, ' ')
            .replace(/\b\w/g, char => char.toUpperCase());
    }

    const pageParentUrl = getFirstPathSegment();

    const pageTitle = transformString(pageParentUrl);

    const coursesByCat = courses.filter(
        (section) =>
        section.name
            .replace(/ /g, "-")
            .replace(/[^a-zA-Z0-9-%]/g, '')
            .toLowerCase() === params.category
    );

    const things = coursesByCat.flatMap((section) => section.things);

    const catNames = coursesByCat.map((section) => section.name);

    const handleClick = (): void => {
        window.location.href = `${window.location.origin}/${pageParentUrl}`;
    };
    const breadcrumbItems: readonly BreadcrumbItem[] = [
        { label: pageTitle === "Courses" ? "Training" : pageTitle, onClick: handleClick },
        { label: catNames[0] ?? '' },
    ];

    return (
        <>
        {!loaded && <PageLoader />}
        {loaded && (
        <Box sx={{overflowX: "hidden", margin: "0 auto", paddingTop: "19px"}} id="mainBox" className="maxWidthOverflow" ref={containerRef}>
            <Box className="titleSection" sx={{ marginTop: "30px" }}>
                <BreadcrumbsNav items={breadcrumbItems} separator="/" prefix="/" showIcon={true} />
            </Box>
            <div className="titleSection">
                <div className="exploreAllTitle"
                    style={{ marginBottom: !isMobile ? '20px' : '0' }}>
                    <h2>{/* {catNames[0]} */} All Courses</h2>
                </div>
                <div className="backToHome"
                    style={{ borderTop: !isMobile ? '1px solid #ECE9E4' : '0' }}>
                    <Box 
                        component="p"
                        onClick={handleClick}
                        sx={{ 
                            color: '#FD3300 !important',
                            cursor: 'pointer',
                            fontSize: '14px !important',
                            fontFamily: 'Repro, sans-serif',
                            fontWeight: 500,
                            "&:hover": {
                                color: '#DB2C00 !important',
                                '& svg path': {
                                    fill: '#DB2C00',
                                },
                            },
                        }}
                    >
                        <svg style={{ marginRight: '5px' }} width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.25 12.875C6.00391 12.875 5.78516 12.793 5.62109 12.6289L0.371094 7.37891C0.015625 7.05078 0.015625 6.47656 0.371094 6.14844L5.62109 0.898438C5.94922 0.542969 6.52344 0.542969 6.85156 0.898438C7.20703 1.22656 7.20703 1.80078 6.85156 2.12891L2.23047 6.75L6.85156 11.3984C7.20703 11.7266 7.20703 12.3008 6.85156 12.6289C6.6875 12.793 6.46875 12.875 6.25 12.875Z" fill="#FD3300"/>
                        </svg>
                         Return to {pageTitle}
                    </Box>
                </div>
            </div>
            <ExploreAllCards coursesByCat={things}/>
            <div className="titleSection">
                <button className="exploreReturnToDashboard" onClick={handleClick}>
                    Return to {pageTitle}
                </button>
            </div>
        </Box>)}
        </>
    );
}